module.exports = __webpack_public_path__ + "static/img/Books.7790e27.png";